export const purchaseMotionLocations = {
  CALCULATOR: 'CALCULATOR',
  CMS_UPGRADE_MODAL: 'CMS_UPGRADE_MODAL',
  DEFAULT_PAYWALL: 'DEFAULT_PAYWALL',
  EMBEDDED_CHECKOUT: 'EMBEDDED_CHECKOUT',
  EXTENDED_MERCH_CARD: 'EXTENDED_MERCH_CARD',
  GENERIC: 'GENERIC',
  GETTING_STARTED: 'GETTING_STARTED',
  LEGACY_PRICING_PAGE: 'LEGACY_PRICING_PAGE',
  MERCH_CARD: 'MERCH_CARD',
  PAYMENT_PAYWALL: 'PAYMENT_PAYWALL',
  PRICING_PAGE_INTERSTITIAL: 'PRICING_PAGE_INTERSTITIAL',
  REMOVE_BRANDING_BANNER: 'REMOVE_BRANDING_BANNER',
  SERVICE_HUB_PAYWALL: 'SERVICE_HUB_PAYWALL',
  TALK_TO_SALES_BUTTON: 'TALK_TO_SALES_BUTTON',
  TRIAL_BANNER: 'TRIAL_BANNER',
  TRIAL_GUIDE: 'TRIAL_GUIDE',
  TRIAL_MODAL: 'TRIAL_MODAL',
  UPGRADE_MODAL: 'UPGRADE_MODAL',
  USAGE_LIMIT_BANNER: 'USAGE_LIMIT_BANNER',
  USC_HELP_WIDGET: 'USC_HELP_WIDGET',
  WORKFLOWS_PAYWALL: 'WORKFLOWS_PAYWALL',
  HUBSPOT_CREDITS_MERCH_CARD_SMALL: 'HUBSPOT_CREDITS_MERCH_CARD_SMALL',
  HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE: 'HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE',
  USAGE_LIMIT_COUNTER: 'USAGE_LIMIT_COUNTER',
  UPGRADE_PAGE: 'UPGRADE_PAGE'
};
export const UPGRADE_POINT_LOCATIONS = [purchaseMotionLocations.DEFAULT_PAYWALL, purchaseMotionLocations.REMOVE_BRANDING_BANNER, purchaseMotionLocations.UPGRADE_MODAL, purchaseMotionLocations.UPGRADE_PAGE, purchaseMotionLocations.USAGE_LIMIT_BANNER, purchaseMotionLocations.USAGE_LIMIT_COUNTER, purchaseMotionLocations.WORKFLOWS_PAYWALL];